import SwiperCarousel from "./components/swiper-carousel";
import ScrollAnimation from "./components/scroll-animation";

SwiperCarousel.init();
ScrollAnimation.init();
